// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"4445fcb4","2500":"b899fd48","2633":"b41d1c1a","3346":"9af13084","7025":"b8429f5a","8964":"4505f902"}[chunkId] + "-1793730954280.js";
};